import { render, staticRenderFns } from "./HistoryReportDetails.vue?vue&type=template&id=1ef09640&scoped=true&"
import script from "./HistoryReportDetails.vue?vue&type=script&lang=js&"
export * from "./HistoryReportDetails.vue?vue&type=script&lang=js&"
import style0 from "./HistoryReportDetails.vue?vue&type=style&index=0&id=1ef09640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef09640",
  null
  
)

export default component.exports